import { useEffect, useMemo, useState } from 'react'

const MINUTE_MS = 60_000
const NEXT_MINUTE_FUDGE_MS = 100

function getNextMinuteDelay(nowMs = Date.now()) {
  return MINUTE_MS - (nowMs % MINUTE_MS) + NEXT_MINUTE_FUDGE_MS
}

export function usePosFulfillmentAvailabilityNow(enabled) {
  // oxlint-disable-next-line react/purity -- grandfathered
  const enabledSnapshot = useMemo(() => ({ enabled, now: new Date() }), [enabled])
  const [timerNow, setTimerNow] = useState(null)

  useEffect(() => {
    if (!enabled) {
      return undefined
    }

    let timeoutId

    const scheduleNextTick = () => {
      timeoutId = window.setTimeout(() => {
        setTimerNow(new Date())
        scheduleNextTick()
      }, getNextMinuteDelay())
    }

    scheduleNextTick()

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [enabled])

  return enabled && timerNow && timerNow >= enabledSnapshot.now ? timerNow : enabledSnapshot.now
}
